/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const _AccommodationInvoiceState = {
  id: null,
  invoice_type: '',
  status: '',
  total: null,
  currency: '',
  customerid: '',
  invoiceid: '',
  invoice_url: '',
  note: '',
  guest_name: '',
  room_name: '',
  check_in: '',
  check_out: ''
}

class AccommodationInvoiceState extends Record(_AccommodationInvoiceState) {
  mergeModel(model) {
    return this.merge(model)
  }

  getInvoiceTypeLabel() {
    switch (this.invoice_type) {
      case 'accommodation_fee':
        return '宿泊費'
      case 'accommodation_tax':
        return '宿泊税'
      case 'accommodation_fee_and_tax':
        return '宿泊費と宿泊税'
      default:
        return 'その他'
    }
  }

  getStatusLabel() {
    switch (this.status) {
      case 'before_invoice':
        return '請求前'
      case 'invoicing':
        return '請求中'
      case 'paid':
        return '支払済み'
      case 'uncollectible':
        return '未払い'
      case 'refunded':
        return '返金済み'
      default:
        return '不明'
    }
  }
}

export { AccommodationInvoiceState }
